@if (tplItem?.helpTooltip?.text) {
  <span
    class="ft-help-icon"
    tabindex="0"
    role="img"
    [attr.aria-label]="tplItem?.helpTooltip?.text"
  >
    <span class="material-icons md-18" aria-hidden="true">{{tplItem?.helpTooltip?.icon || 'help'}}</span>
    <span class="ft-help-tooltip" role="tooltip">{{tplItem?.helpTooltip?.text}}</span>
  </span>
}
